import React, { createContext, useState } from 'react';

// import jsonData from './sampleData.json';
export const DataContext = createContext();
const API_KEY = 'GpehrOVEzB'

export const DataProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (transcriptFile, attendanceFile) => {
    setLoading(true);
    setError(null);

    console.log('Transcript File:', transcriptFile); // Debugging log
    console.log('Attendance File:', attendanceFile); // Debugging log

    if (!transcriptFile || !attendanceFile) {
        setError('Both files are required.');
        setLoading(false);
        return;
    }
    
    try {
        const formData = new FormData();
        formData.append('transcriptFile', transcriptFile);
        formData.append('attendanceFile', attendanceFile);

        const response = await fetch('https://h62lphoyl23nj25gii6kg4pvti0pxcjh.lambda-url.us-east-1.on.aws/', { // Use relative path
            method: 'POST',
            headers: {
                'x-api-key': API_KEY,
                'Accept': 'application/json',
            },
            body: formData
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error('API Error:', errorText);
            throw new Error(`API error: ${response.status}`);
        }

        const jsonData = await response.json();
        setData(jsonData);
    } catch (err) {
        console.error('Fetch error:', err);
        setError(err.message);
    } finally {
        setLoading(false);
    }
};

return (
  <DataContext.Provider value={{ data, loading, error, fetchData }}>
    {children}
  </DataContext.Provider>
);
};